const SH_C0 = 0.28209479177387814;

/**
 * Clamps a numeric value to the normalized [0, 1] range.
 */
export function clamp01(value) {
  return Math.max(0, Math.min(1, value));
}

/**
 * Converts an unsigned 8-bit color component to [0, 1].
 */
export function byteToUnitFloat(value) {
  return value / 255;
}

/**
 * Converts a degree-zero spherical-harmonic coefficient to a
 * normalized color component.
 */
export function shDCToColor(value) {
  return clamp01(0.5 + SH_C0 * value);
}
